module.exports = __webpack_public_path__ + "static/media/QH.7a771e3e.svg";